import { createRouter, createWebHistory } from "vue-router";
import Home from "@/views/Home.vue";
import Register from "@/views/register/Register.vue";
import Register_1 from "@/views/register/Register_1.vue";
import Register_2 from "@/views/register/Register_2.vue";
import Register_3 from "@/views/register/Register_3.vue";
import Profile from "@/views/profile/Profile.vue";
import Edit from "@/views/edit/Edit.vue";
import Edit_1 from "@/views/edit/Edit_1.vue";
import Dashboard from "@/views/dashboard/Dashboard.vue";
import Dashboard_history from "@/views/dashboard/Dashboard_history.vue";

import Register_health_self from "@/views/register/Register_health_self.vue";
import Register_health_other1 from "@/views/register/Register_health_other1.vue";
import Register_health_other2 from "@/views/register/Register_health_other2.vue";
import Register_health_other3 from "@/views/register/Register_health_other3.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
  },
  {
    path: "/register/step1",
    name: "Register_1",
    component: Register_1,
  },
  {
    path: "/register/step2",
    name: "Register_2",
    component: Register_2,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/edit",
    name: "Edit",
    component: Edit,
  },
  {
    path: "/edit/step1",
    name: "Edit_1",
    component: Edit_1,
  },

  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },

  {
    path: "/dashboard_history",
    name: "Dashboard_history",
    component: Dashboard_history,
  },



  {
    path: "/register/step3",
    name: "Register_3",
    component: Register_3,
  },


  {
    path: "/register/register_health_self",
    name: "Register_health_self",
    component: Register_health_self,
  },

  {
    path: "/register/register_health_other1",
    name: "Register_health_other1",
    component: Register_health_other1,
  },
  {
    path: "/register/register_health_other2",
    name: "Register_health_other2",
    component: Register_health_other2,
  },
  {
    path: "/register/register_health_other3",
    name: "Register_health_other3",
    component: Register_health_other3,
  },



];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
